import { CommonService } from "@/services/Common.service";
import { AuthenService } from "@/services/authen.service.ts";

export class SyncService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private commonAPI = process.env.VUE_APP_API_COMMON_URL;
  private commonService = new CommonService();
  private authService = new AuthenService();

  constructor() {}

  async getSyncTableList() {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/sync`);
    if (result) {
      return result.data;
    } else {
      return error;
    }
  }

  public async getTables() {
    const { result, error } = await this.commonService.get(`${this.baseAPI}/admin/group-company`);
    if (result) {
      return result.data;
    } else {
      return this.authService.handleError(error, "getTables");
    }
  }

  syncTable(data: any) {
    return this.commonService.put(`${this.baseAPI}/admin/sync`, data);
  }

  addDbForSync(data: any) {
    return this.commonService.post(`${this.baseAPI}/admin/group-company`, data);
  }
}
